<template>
  <div >
      <i @click="upBox" class="el-icon-search" title="查询" style="margin-left: 20px;font-size: 15px"></i>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        value: null,
        number: null,
      }
    },
    mounted() {

    },
    methods: {
      upBox() {
        this.$emit('clickModule')
      }
    }
  }
</script>
<style scoped>
  .stepSuc :hover {
    cursor: pointer;
  }
</style>